/**
* @file 战队-基础信息
* @author 余凯
*/

import React from 'react'
import './index.less'
import {
  Tabs, Button,
  Form,
  message,
  Select,
  Input,
  Icon,
} from 'antd'

import { connect } from 'react-redux'
import Actions from '../../../../apis/team'
import { getTeamBaseInfo, dispatchSetTeamInfo } from '@/redux/teamRedux'

const { Option } = Select;
const { TabPane } = Tabs;
const { TextArea } = Input;

const MAX_FILE_SIZE = 200 * 1024
@connect(
  state => state.teamReducer,
  { getTeamBaseInfo, dispatchSetTeamInfo }

)
@Form.create()
class FormPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
    }
  }

  componentDidMount() {

  }

  handleAnnSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields(['team_bulletin'], (err, values) => {
      if (!err) {
        const parmas = {
          id: this.props.id,
          // team_slogan: values.team_slogan,
          // team_desc: values.team_desc,
          game_id: this.props.game,
          team_bulletin: values.team_bulletin
        }

        Actions.putTeamBulletin(parmas).then(res => {
          if (res.code == 200) {
            this.props.onFormSubmit('sum')
          }
        })
      }
    });
  }

  handleBaseSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields(['team_desc', 'team_slogan', 'file'], (err, values) => {
      if (!err) {
        const parmas = {
          id: this.props.id,
          // team_slogan: values.team_slogan,
          // team_desc: values.team_desc,
          // game_id: this.props.game
        }

        let formData = new FormData();
        formData.append('id', this.props.id)
        formData.append('team_slogan', values.team_slogan)
        formData.append('team_desc', values.team_desc)
        formData.append('game_id', this.props.game)
        if (values.file)  formData.append('file', values.file)
        Actions.putTeamBaseInfo(parmas, formData).then(res => {
          if (res.code == 200) {
            this.props.onFormSubmit('sum')
          }
        })
      }
    });
  };

  normFile = e => {
    if (Array.isArray(e)) {
      return e;
    }
    return e && e.fileList;
  };

  getBase64 = (img, callback) => {
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result));
    reader.readAsDataURL(img);
  }

  beforeUpload = (file) => {
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
    if (!isJpgOrPng) {
      message.error('请上传JPG/PNG格式图片!');
    }
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
      message.error('图片超过2MB!');
    }

    return isJpgOrPng && isLt2M;
  }

  handleChange = info => {
    if (info.file.status === 'uploading') {
      this.setState({ loading: true });
      return;
    }
    if (info.file.status === 'done') {
      // Get this url from response in real world.
      this.getBase64(info.file.originFileObj, imageUrl => this.setState({
        imageUrl,
        loading: false,
      }),
      );
    }
  };

  handleClassFileChange = e => {
    const file = e.target.files[0]
    if (file) {
      if (file.size <= MAX_FILE_SIZE) {
        this.getBase64(file, imageUrl => this.setState({
          imageUrl,
        }));
        this.props.form.setFieldsValue({
          file
        })
      } else {
        message.error('文件过大')
        this.file.value = ''
        this.props.form.setFieldsValue({ file: '' })
        this.setState({ imageUrl: null })
      }
    }
  }

  render() {
    const { getFieldDecorator } = this.props.form;
    const { team_bulletin: teamBulletin, team_slogan: teamSlogan, team_desc: teamDesc, flag, logo_image: logoImage } = this.props.teamBaseInfo || {}
    const formItemLayout = {
      labelCol: { span: 3 },
      wrapperCol: { span: 17 },
    };
    const uploadButton = (
      <div>
        <Icon type={this.state.loading ? 'loading' : 'plus'} />
        <div className="ant-upload-text">Upload</div>
      </div>
    );
    const { imageUrl } = this.state
    return (
      <div className="team_home" id="team_home">
        <div className="form_page">
          <Tabs defaultActiveKey="1" size="small" >
            <TabPane tab="基础信息" key="1">
              {this.props.teamBaseInfo
              && (
                <Form {...formItemLayout} onSubmit={this.handleBaseSubmit}>
                  <Form.Item label="战队口号">
                    {
                      getFieldDecorator(
                        'team_slogan',
                        {
                          initialValue: teamSlogan,
                          rules: [{ required: true, message: '请输入战队口号！' }]
                        },
                      )(<Input placeholder="请注意控制字数，最多不超过20字" maxLength={20} />)
                    }
                  </Form.Item>

                  <Form.Item label="战队简介">
                    {
                      getFieldDecorator(
                        'team_desc',
                        {
                          initialValue: teamDesc,
                          rules: [{ required: true, message: '请输入战队简介！' }]
                        }
                      )(<TextArea placeholder="请注意控制字数，最多不超过200字" autoSize maxLength={200} />)
                    }
                  </Form.Item>
                  {/* {this.props.teamBaseInfo.flag ?  ( */}
                  <Form.Item label="战队图标" extra={flag ? '图片不要大于200KB' : '图片正在审核中不可编辑'}>
                    {getFieldDecorator('file', {
                      //  "valuePropName": 'fileList',
                      //  "getValueFromEvent": this.normFile,
                    })(
                      <>
                        <input
                          ref={node => this.file = node}
                          type="file"
                          disabled={!flag}
                          accept="image/jpeg,image/jpg"
                          className="base-upload-input"
                          onChange={this.handleClassFileChange}
                        />
                        {imageUrl ||  logoImage ? <img src={imageUrl || (logoImage)} alt="avatar" style={{ width: '150px', height: '150px', marginTop: '20px' }} /> : ''}
                      </>

                    )}
                  </Form.Item>
                  <Form.Item wrapperCol={{ span: 12, offset: 3 }}>
                    <Button style={{ marginRight: '20px' }} onClick={() => this.props.onFormCancel()}>
                    取消
                    </Button>
                    <Button type="primary" htmlType="submit">
                    提交
                    </Button>
                  </Form.Item>
                </Form>
              )}
            </TabPane>
            <TabPane tab="发布公告" key="2">
              <Form {...formItemLayout} onSubmit={this.handleAnnSubmit}>
                <Form.Item label="战队公告">
                  {
                    getFieldDecorator(
                      'team_bulletin',
                      {
                        initialValue: teamBulletin,
                        rules: [{ required: true, message: '请输入战队公告！' }]
                      }
                    )(<TextArea placeholder="请注意控制字数，最多不超过200字" autoSize maxLength={200} />)
                  }
                </Form.Item>

                <Form.Item wrapperCol={{ span: 12, offset: 3 }}>
                  <Button style={{ marginRight: '20px' }} onClick={() => this.props.onFormCancel()}>
                    取消
                  </Button>
                  <Button type="primary" htmlType="submit">
                    提交
                  </Button>
                </Form.Item>
              </Form>
            </TabPane>
          </Tabs>
        </div>
      </div>
    );
  }
}

export default FormPage;
